import Vue from 'vue';

const state = Vue.observable({
  toasts: [],
});

let nextId = 0;

function add(message, type = 'info', duration = 4000) {
  const id = ++nextId;
  state.toasts.push({ id, message, type });
  setTimeout(() => remove(id), duration);
}

function remove(id) {
  const idx = state.toasts.findIndex(t => t.id === id);
  if (idx !== -1) state.toasts.splice(idx, 1);
}

export const toastState = state;
export const removeToast = remove;

const ToastPlugin = {
  install(Vue) {
    Vue.prototype.$toast = {
      success: (msg) => add(msg, 'success'),
      error:   (msg) => add(msg, 'error'),
      warn:    (msg) => add(msg, 'warn'),
      info:    (msg) => add(msg, 'info'),
    };
  },
};

export default ToastPlugin;
